import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SortDirection, SourcingEventSortField, useListCombinedEventsForBuyerQuery } from "../../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../../common/auth/useLoggedInWithOrgContextState";
import { useDisplayDate } from "../../../../common/formatting/useDisplayDate";
import { urls } from "../../../../urls";
import { useEventNavigation } from "../../../sourcing-events/useEventNavigation";
import { DRAFT_V2_STATUSES, eventsCreatedBy } from "../homeEventStatuses";
import { HomePanel } from "./HomePanel";

const FETCH_LIMIT = 50;
const DISPLAY_LIMIT = 5;

export const LatestDraftsPanel = () => {
  const { t } = useTranslation();
  const authState = useLoggedInWithOrgContextState();
  const displayDate = useDisplayDate();
  const navigateToEvent = useEventNavigation();

  const { data, isLoading, isError } = useListCombinedEventsForBuyerQuery({
    orgId: authState.selectedOrg.id,
    statuses: DRAFT_V2_STATUSES,
    sortBy: SourcingEventSortField.ModifiedAt,
    sortDirection: SortDirection.Desc,
    limit: FETCH_LIMIT,
  });
  const drafts = eventsCreatedBy(data?.events ?? [], authState.me.id).slice(0, DISPLAY_LIMIT);

  return (
    <HomePanel titleKey="My latest in progress" seeAllTo={`${urls.v2.sourcingEvents.viewAll}?status=arbeid`} isLoading={isLoading} isError={isError} isEmpty={drafts.length === 0} emptyKey="Nothing in progress">
      <Table variant="simple" size="sm">
        <Thead><Tr><Th>{t("Title")}</Th><Th>{t("Last edited by me")}</Th></Tr></Thead>
        <Tbody>
          {drafts.map((event) => (
            <Tr key={event.id} cursor="pointer" _hover={{ bg: "smPrimarySofter" }} onClick={() => navigateToEvent(event)}>
              <Td fontWeight="medium" color="smText">{event.title || t("Untitled")}</Td>
              <Td color="smMuted" fontSize="sm">{displayDate(event.modifiedAt)}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </HomePanel>
  );
};
